import React from 'react'
import { MDBBtn, MDBModal} from 'mdb-react-ui-kit';

import style from './style.module.scss';

function ImageDetail({src, isOpen, onClose}) {
  return (
    <MDBModal tabIndex='-1' show={isOpen} draggable className={style.modal}>
        <div className={style.btnClose}>
                <MDBBtn
                type='button'
                className='btn-close' 
                color='none'
                onClick={onClose}
                style={{backgroundColor: 'white'}}
              ></MDBBtn>
              </div>
        <div >
            <img src={src} alt='image_detail' className={style.image} />
        </div>
    </MDBModal>
  )
}

export default ImageDetail